{
	"title": "Услугата е недостъпна (500)",
	"description": "Опитайте да презаредите тази страница или проверете интернет връзката си. Ако тази грешка продължава, моля, докладвайте я като бъг, за да можем да предприемем действия.",
	"primaryButtonTitle": "Презареди страницата",
	"secondaryButtonTitle": "Копирай журнала за грешки",
	"errorLogCopiedMessage": "Журналът за грешки е копиран",
	"traceparentLabel": "Traceparent"
}
